var getters = {
  token: function token(state) {
    return state.user.token;
  },
  theme: function theme(state) {
    return state.user.theme;
  },
  isLock: function isLock(state) {
    return state.user.isLock;
  },
  menuList: function menuList(state) {
    return state.user.menuList;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  permissionList: function permissionList(state) {
    return state.user.permissionList;
  },
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  language: function language(state) {
    return state.app.language;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  dictionaryList: function dictionaryList(state) {
    return state.base.dictionaryList;
  },
  userList: function userList(state) {
    return state.base.userList;
  },
  positionList: function positionList(state) {
    return state.base.positionList;
  },
  roleList: function roleList(state) {
    return state.base.roleList;
  },
  socket: function socket(state) {
    return state.user.socket;
  },
  hasTable: function hasTable(state) {
    return state.generator.hasTable;
  },
  leftMenuList: function leftMenuList(state) {
    return state.user.leftMenuList;
  }
};
export default getters;